import React from 'react';
import PropTypes from 'prop-types';

import {Box, Skeleton} from 'views/components';

import moment from 'moment';

const WeeklySkeleton = (props) => {
  const {weekDays} = props;

  const days = weekDays?.length ? weekDays : Array(7).fill(null).map((_, i) => {
    const date = moment().startOf('week').add(i, 'days');
    return date;
  });

  return days.map((day, colIdx) => {
    const momentDate = moment(day);
    const today = moment().startOf('day');
    return (
      <Box
        key={colIdx}
        sx={{
          width: `calc((100% - 220px) / 7)`,
          px: 0.5,
          py: 0.5,
          borderRight: colIdx < days.length - 1 ? '1px solid #ccc' : 'none',
          backgroundColor: momentDate.isSame(today, 'day') ? '#f8fbff' : 'transparent',
        }}
      >
        <Skeleton
          variant="rounded"
          height={40}
          width="100%"
        />
      </Box>
    );
  });
};

WeeklySkeleton.propTypes = {
  weekDays: PropTypes.arrayOf(PropTypes.object),
};

export default WeeklySkeleton;
